
export const  validateNoErrors = (key, value) => {
    switch (key) {
      case "telephones":
        return /^\d{10}$/.test(value) ? true : false;
      case "email":
        return /^[^@]+@[^@]+\.[a-zA-Z;@.\d\w\D\W]{2,}$/.test(value) ? true : false;
        case "rfc":
        return /^[\da-zA-Z]{12,13}$/gi.test(value) ? true : false;
        case "razonSocial":
        return !/(S.A. DE C.V.)$|(S.A.)$|(S.A.S.)$|(S.A. de C.V.)$|(S. de R.L.)$|(S.C.)$/gi.test(value) ? true : false;
        case "password":
          return /.{8,}$/gi.test(value) ? true : false;
      default:
        return false;
    }
}

